var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticStyle:{"height":"3rem"},attrs:{"type":"text","placeholder":"Enter (partial) first- and/or last name"},domProps:{"value":_vm.filteredvalue},on:{"input":_vm.debounceInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }